import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';

import { ReadInBrowser as ReadInBrowserIcon, ExternalArrow } from '@bibliocommons/deprecated-base-icons';
import { Link } from '@bibliocommons/base-links';

import './CheckedOutReadingLinks.scss';

export default class ThirdPartyReaderLink extends React.PureComponent {
  render() {
    const { className, withIcons } = this.props;

    return (
      <Link
        target="_blank"
        href={this.props.thirdPartyReaderUrl}
        className={cn('cp-third-party-reader-link', className)}
        dataKey="link_thirdparty_reader"
        screenReaderText={<FormattedMessage id="open_in_third_party_reader" />}
      >
        {withIcons && <ReadInBrowserIcon />}
        <span aria-hidden>
          <FormattedMessage id="open_in_third_party_reader" />
        </span>
        <ExternalArrow />
      </Link>
    );
  }
}

ThirdPartyReaderLink.propTypes = {
  thirdPartyReaderUrl: PropTypes.string,
  withIcons: PropTypes.bool,
  className: PropTypes.string
};
